<div *ngIf="videoReviewers$ | async as reviewers">
	<div *ngIf="reviewers.length" class="video-reviewers-list">
		<div class="table-headers">
			<div class="left-header guest-name-header" translate="common_user"></div>
			<div class="right-header" translate="common_email"></div>
		</div>
		<ul class="guest-list">
			<li *ngFor="let g of reviewers" class="list-item">
				<div class="guest-type-icon">
					<i class="ficon-app-email" *ngIf="g.hasOwnProperty('uuid') && g.uuid !== null"
						matTooltipPosition="above"
						[matTooltip]="'session-editor-panel_invited-through-email' | translate"></i>
					<i class="ficon-app-link" *ngIf="g.uuid === null"
						matTooltipPosition="above"
						[matTooltip]="'session-editor-panel_invited-through-public-link' | translate"></i>
					<i class="ficon-app-internal-reviewer" *ngIf="!g.hasOwnProperty('uuid')"
						matTooltipPosition="above"
						[matTooltip]="'session-editor-panel_invited-internal-reviewer' | translate"></i>
				</div>
				<div class="user-name">
					<span>{{ getUserName(g) }}</span>
					<div class="email-mobile">
						<span class="email">{{getEmail(g)}}</span>
						<span *ngIf="!g.user_id" class="pending-guest">- pending</span>
					</div>

				</div>
				<div class="user-email">
					<span class="email"
						[class]="{ 'pending-email': !g.user_id }"
						matTooltipPosition="above"
						[matTooltip]="getEmail(g)">
						{{getEmail(g)}}
					</span>
					<span *ngIf="!g.user_id" class="pending-guest">- pending</span>
				</div>
				<div class="btn-none right-button">
					<button
						type="button"
						class="btn-none remove-guest-btn"
						[attr.aria-label]="getDeleteAriaLabel(g)"
						[matTooltip]="(g.user_id ? 'session-editor-panel_external-reviewers-delete' : 'group-settings_delete-invite') | translate"
						matTooltipPosition="above"
						(click)="removeGuest(g)">
						<i class="ficon-app-x"></i>
					</button>
				</div>
			</li>
		</ul>
	</div>
</div>

<div *ngIf="(videoReviewers$ | async).length === 0" class="empty-state-text">
	{{ 'session-editor-panel_guest-reviewers-empty-state' | translate }}
</div>
